import { useLayoutEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * A NEW PAGE OPENS AT THE TOP (owner 2026-10-08, from the demo rehearsal).
 *
 * The app is one long-lived window, so moving between pages kept the previous
 * page's `scrollY`: Budgeting, the Breakdown and My Tasks opened part-way down
 * with their titles under the impersonation banner, and the Breakdown Timeline
 * — shorter than the page it came from — looked EMPTY because the leftover
 * offset pushed the chart out of view.
 *
 * Fires only when the PATHNAME changes on a PUSH or REPLACE:
 *  · browser Back / Forward (POP) is left alone;
 *  · a same-page change — search params, a `#tab` hash, the hires card's
 *    same-URL history entry — never scrolls, so nothing jumps under the user;
 *  · a deep link (`?order=`, `?hire=`) still opens at the top first and its
 *    own row scroll (`hooks/useOpenAtTop#scrollUnderPinnedChrome`) runs after.
 * Renders nothing. Mounted once, inside the router (`App.js`).
 */
export default function ScrollToTopOnPageChange() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const lastPathname = useRef(pathname);

  useLayoutEffect(() => {
    if (pathname === lastPathname.current) return;
    lastPathname.current = pathname;
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);

  return null;
}
